module.exports = __webpack_public_path__ + "1b657aa24a301781d0eadb1ae6a18e60.jpg";